// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TaTransparencyBreakdownEntryFromJSON(json) {
    return {
        'ageInYears': !exists(json, 'ageInYears') ? undefined : json['ageInYears'],
        'predicted': !exists(json, 'predicted') ? undefined : json['predicted'],
        'observedMean': !exists(json, 'observedMean') ? undefined : json['observedMean'],
        'p10': !exists(json, 'p10') ? undefined : json['p10'],
        'p25': !exists(json, 'p25') ? undefined : json['p25'],
        'p50': !exists(json, 'p50') ? undefined : json['p50'],
        'p75': !exists(json, 'p75') ? undefined : json['p75'],
        'p90': !exists(json, 'p90') ? undefined : json['p90'],
    };
}
export function TaTransparencyBreakdownEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'ageInYears': value.ageInYears,
        'predicted': value.predicted,
        'observedMean': value.observedMean,
        'p10': value.p10,
        'p25': value.p25,
        'p50': value.p50,
        'p75': value.p75,
        'p90': value.p90,
    };
}
